import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "textarea", "hiddenInput" ]
  static values = {
    mode: { type: String, default: "ace/mode/json" },
    theme: { type: String, default: "ace/theme/crimson_editor" },
    minLines: { type: Number, default: 10 },
    maxLines: { type: Number, default: 100 },
    readOnly: { type: Boolean, default: false }
  }

  connect() {
    this.editor = ace.edit(this.textareaTarget)
    this.editor.getSession().setMode(this.modeValue)
    this.editor.setTheme(this.themeValue)
    this.editor.$blockScrolling = Infinity
    this.editor.setShowPrintMargin(false)
    this.editor.setOptions({
      minLines: this.minLinesValue,
      maxLines: this.maxLinesValue
    })
    if (this.readOnlyValue) {
      this.editor.setReadOnly(true)
      this.editor.setHighlightActiveLine(false)
      this.editor.setHighlightGutterLine(false)
    }
    this.editor.on('change', () => {
      if (this.hasHiddenInputTarget) {
        this.hiddenInputTarget.value = this.editor.getSession().getValue()
      }
      this.dispatch("change")
    })
  }

  disconnect() {
    this.editor.destroy()
    this.editor = null
  }
}
